// Import model
import { CreatePickListItemRequest } from '../models/CreatePickListItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreatePickListItemRequest - handles JSON serialization and deserialization with type validation
 */
export class CreatePickListItemRequestSerializer {
  /**
   * Deserializes a JSON string into a CreatePickListItemRequest instance
   */
  static deserialize(json: string): CreatePickListItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreatePickListItemRequest instance
   */
  static fromObject(obj: any): CreatePickListItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreatePickListItemRequest');
    }


    const instance: CreatePickListItemRequest = {
      createdBy: obj['createdBy'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      itemId: obj['itemId'] as string,
      pickListId: obj['pickListId'] as string,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreatePickListItemRequest instances
   */
  static deserializeArray(json: string): CreatePickListItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreatePickListItemRequest instance to a JSON string
   */
  static serialize(instance: CreatePickListItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreatePickListItemRequest instance to a plain object
   */
  static toObject(instance: CreatePickListItemRequest): any {
    return {
      'createdBy': instance.createdBy,
      'isActive': instance.isActive,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'name': instance.name,
      'description': instance.description,
      'itemId': instance.itemId,
      'pickListId': instance.pickListId,
    };
  }

  /**
   * Serializes an array of CreatePickListItemRequest instances to a JSON string
   */
  static serializeArray(instances: CreatePickListItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
